import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class QuerystringService {

  constructor() { }

  getParamValue(paramName: string) {
    const url = window.location.href;
    let paramValue;

    if (url.includes('?')) {
      const httpParams = new HttpParams({ fromString: url.split('?')[1] });
      paramValue = decodeURIComponent((httpParams.get(paramName) + '').replace(/\+/g, '%20'));
    }

    return paramValue;
  }
}
